import { selectors } from '@amplement/backend-connector';

import useRoomSelector from './useRoomSelector';

const useMyStreamSelector = (_room) =>
    useRoomSelector(selectors.rooms.getMyRoomStreamInfoByRoomIdSelector, _room);

export default useMyStreamSelector;
